export default __webpack_public_path__ + "static/media/new_room_2.10197fd8.png";